module.exports = __webpack_public_path__ + "static/media/RBG_art_Leonardo_Santamaria.890dc669.png";